import Menu from './Compartido/Menu.jsx';
import Footer from './Compartido/Footer.jsx';
import DatosReserva from './GestionaReserva/DatosReserva.jsx';



const GestionaReserva = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.websgrupo}
                ruta={props.ruta}
                destinoslarga={props.destinoslarga}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
            />
            <DatosReserva
                reserva={props.reserva}
                lang={props.lang}
                paises={props.paises}
                tiposdocs={props.tiposdocs}
                idiomas={props.idiomastodos}
                config={props.websgrupo}
            />
            <Footer
                datos={props.websgrupo}
                lang={props.lang}
                ruta={props.ruta}
                logos_pie={props.logos_pie}
                websgrupo={props.websgrupo}
            />
        </main>
    )
}

export default GestionaReserva;
